import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import "./resuable.css";

function RedirectBack({ steps = -1, from = '' }) {
  const navigate = useNavigate();

  const handleRedirectBack = () => {
    if (window.history.length > 1) {
      navigate(steps, { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  };

  return (
    <div className="redirect-back" onClick={() => handleRedirectBack()}>
      <IoIosArrowBack />
      <span>Back</span>
    </div>
  );
}

export default RedirectBack;
